import { Tooltip } from '@material-ui/core';
import ActionButton, { MENU_BUTTON_CATEGORY } from 'src/components/UI/ActionButton';
import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { ButtonProps } from '@material-ui/core/Button/Button';
import GetAppIcon from '@material-ui/icons/GetApp';
import { t } from 'src/lib/language';
import { postDownloadSelectedEntitesAction } from 'src/redux/actions/querybuilderActions';
import { FORM, FORM_STATUS } from 'src/constants/Form';
import { ENTITIES } from 'src/models/QuerybuilderModel';
import { DELIVERY_TYPE, FORMAT, ORIENTATION } from 'src/models/DownloadModel';

const UserDownloadInvoiceButton = (props: ButtonProps) => {
  const { disabled } = props;
  const dispatch = useAppDispatch();
  const processing = useSelector(
    (state: Store) => state.formStatus[FORM.query_builder] === FORM_STATUS.processing,
  );
  const lang = useSelector((state: Store) => state.language.language);
  const selections = useSelector((state: Store) => {
    if (!!state.selected[ENTITIES.invoices]) {
      return [...state.selected[ENTITIES.invoices]];
    }
    return [];
  });
  const handleOpen = () => {
    dispatch(postDownloadSelectedEntitesAction(
      ENTITIES.invoices,
      selections,
      {
        file: 'Invoices.pdf',
        orientation: ORIENTATION.portrait,
        format: FORMAT.pdf,
        delivery: DELIVERY_TYPE.download,
      },
    ));
  };

  return (
    <>
      <Tooltip
        title={t(lang, 'menus.download_invoices')}
        placement="top-start">
        <span>
          <ActionButton
            variant="outlined"
            category={MENU_BUTTON_CATEGORY.download}
            onClick={handleOpen}
            loading={processing}
            disabled={disabled}>
            <GetAppIcon />
          </ActionButton>
        </span>
      </Tooltip>
    </>
  );
};

export default UserDownloadInvoiceButton;
